export const IconVacancyOfferVacancy20: {
  name: 'icon_vacancy_offer_vacancy_20-f4e6adba94ca'
} = {
  name: 'icon_vacancy_offer_vacancy_20-f4e6adba94ca'
}
